import type { BATCH_SETTINGS } from './constants';
export type BatchItemT = {
  id: string;
  title: string;
  description?: string;
  status?: {
    text: string;
    type: BatchItemStatusT;
  };
  content?: {
    label: string;
    value: string;
  }[];
  hidden?: boolean;
};
export type BatchItemPermissionsT = {
  canTakeActions: boolean;
  isEditable: boolean;
  canComment: boolean;
};
export const BATCH_ITEM_STATUS = ({
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS',
  PENDING: 'PENDING'
} as const);
export type BatchItemStatusT = (typeof BATCH_ITEM_STATUS)[keyof typeof BATCH_ITEM_STATUS];
export type BatchSettingsT = (typeof BATCH_SETTINGS)[keyof typeof BATCH_SETTINGS];